export const featureTypes = Object.freeze({
    QUIZ: 'quiz',
    JEOPARDY: 'jeopardy',
})
